import { atom } from 'jotai';
import { LzTMediaStateData } from '@lz-types/types';

const lzSCommonsMediaBrowserDataAtom = atom<LzTMediaStateData | null>(null);

export default lzSCommonsMediaBrowserDataAtom;
